import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VDialog,{attrs:{"width":"833","height":"650"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VCarousel,{attrs:{"cycle":false,"height":"650","interval":"9999999"}},_vm._l((_vm.images),function(image,index){return _c(VCarouselItem,{key:'carousel-'+index,staticStyle:{"width":"auto","height":"600px"},attrs:{"src":image}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }